import React from "react";
import Reveal from "./Reveal";
import ProductCard from "./ProductCard";
import { NEW_ARRIVALS } from "../data/data";
import { useCart } from "../context/CartContext";

export function NewArrivals() {
  const { addToCart } = useCart();
  return (
    <section className="py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <Reveal>
              <p className="uppercase tracking-widest text-xs mb-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
                Just Landed
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 style={{ fontFamily: "Fraunces, serif" }} className="text-4xl md:text-5xl">New arrivals</h2>
            </Reveal>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {NEW_ARRIVALS.map((p, i) => (
            <ProductCard key={p.name} p={p} index={i} onAdd={addToCart} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default NewArrivals;
